
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input } from '@angular/core';

@Component({
  selector: 'csl-validation-message',
  standalone: true,
  imports: [],
  template: '@if (_show) {<ng-content></ng-content>}',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
  },
})
export class ValidationMessageComponent {
  private cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) name!: string;
  @Input() set show(val: boolean) {
    this._show = val;
    this.cdr.markForCheck();
  }

  _show = false;
}
